import SingleTicket from "./Ticket"

export default SingleTicket
